export const icd10DiagnosisReferenceAddonColumns = [
  'icd_version',
  'code_description',
  'effective_date',
  'expiration_date',
  'revision_date',
  'cc',
];
